{
  "login": "Login",
  "password": "Password",
  "recoveryPassword": "Password reminder",
  "recoveryPasswordText": "Enter your login to remind your password.",
  "signIn": "Log in",
  "signInText": "Use your credentials to log in.",
  "buttons": {
    "signIn": "Log in",
    "password": "Password reminder",
    "recoveryPassword": "Password reminder",
    "backToLogin": "Return to login view"
  }
}
